// Imports ------------------------------------------------------------------->

import {Service, service, inject} from "./di";
import {AuthProvider, AccountsUser} from "../definitions/CommonDefinitions";
import {ConfigService, RuntimeConfig} from "./ConfigService";
import {IAuthenticationService} from "./definitions/IAuthenticationService";
import {DefaultAuthenticator} from "./auth/DefaultAuthenticator";

// Private Definitions ------------------------------------------------------->

// Public Definitions -------------------------------------------------------->

@service("authenticationService")
export class AuthenticationService extends Service implements IAuthenticationService {

	@inject config: ConfigService;

	private delegate: IAuthenticationService;

	init(state?: any) {
		if (this.delegate) {
			return Promise.resolve();
		}
		this.delegate = new DefaultAuthenticator();
		return this.delegate.init(state);
	}

	get status() {
		return this.delegate.status;
	}

	get user() {
		return this.delegate.user;
	}

	login(source: AuthProvider, target?: EventTarget) {
		return this.delegate.login(source, target);
	}

	logout(target?: EventTarget) {
		return this.delegate.logout(target);
	}
}
